import { useEffect } from 'react';
import { useApi, watchSiteChanges } from '../lib/api';

export function useCustomers() {
  const result = useApi('/customers');
  const { reload } = result;
  useEffect(() => watchSiteChanges(reload), [reload]);
  return result;
}